import { render } from "./ChartOrderByMonths.vue?vue&type=template&id=d9fab22e"
import script from "./ChartOrderByMonths.vue?vue&type=script&lang=js"
export * from "./ChartOrderByMonths.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])